<template>
  <div class="p-0 h-100 w-100">
    <div class="row p-0 g-0 h-100 w-100">
      <div class="col-12 h-100 flex flex-row p-0">
        <AdminSidebar class="flex-initial"/>
        <AdminContentLayout class="flex-auto" style="max-height: 100vh; overflow-y: auto"/>
      </div>
      <!-- <div class="col-md-3 col-lg-2">
        <AdminSidebar />
      </div>
      <div class="col-md-9 col-lg-10">
        <AdminContentLayout />
      </div> -->
    </div>
    <FloatingChat v-show="isVisible"/>
  </div>
</template>

<script>
import AdminSidebar from "@/views/components/admin/AdminSidebar.vue";
import AdminContentLayout from "@/views/layouts/AdminContentLayout.vue";
import FloatingChat from "../components/FloatingChat.vue";

export default {
  name: "AdminLayout",
  components: {
    AdminSidebar,
    AdminContentLayout,
    FloatingChat
  },
  data() {
    return {
      isVisible: false
      // drawer: false,
    };
  },
};
</script>
<style scoped>
/* Use /deep/ selector to override the v-application__wrap class */
</style>
